export const SIGNIN_CALL = "SIGNIN_CALL"
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS"
export const SIGNIN_FAILURE = "SIGNIN_FAILURE"
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS"
export const AUTHENTICATION_CHECK_SUCCESS = "AUTHENTICATION_CHECK_SUCCESS"
export const AUTHENTICATION_CHECK_ERROR = "AUTHENTICATION_CHECK_ERROR"
export const USER_PERSONAL_INFO = "USER_PERSONAL_INFO"
export const USER_PERSONAL_INFO_FAILURE = `${USER_PERSONAL_INFO}_FAILURE`
export const USER_PERSONAL_INFO_SUCCESS = `${USER_PERSONAL_INFO}_SUCCESS`
export const USER_PERSONAL_INFO_CALL = `${USER_PERSONAL_INFO}_CALL`
